"use client"

import { useState, useEffect } from "react"
import { DataGrid, GridToolbar } from "@mui/x-data-grid"
import {
  Box,
  useTheme,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tabs,
  Tab,
} from "@mui/material"
import { getAdminData, deleteAdmin, updateAdmin, getTeamMemebers } from "../../data/ApiController.js"
import { useNavigate } from "react-router-dom"
import PasswordModal from "../global/passwordConfirm.jsx"
import Header from "../../components/Header"
import { tokens } from "../../theme"

const AdminList = () => {
  const [getAdmin, setGetAdmin] = useState([])
  const [editableFields, setEditableFields] = useState([])
  const [checkboxStates, setCheckboxStates] = useState({})
  const [selectedRow, setSelectedRow] = useState(null)
  const [open, setOpen] = useState(false)
  const [updatedValues, setUpdatedValues] = useState({})
  const [modalOpen_Confirm, setModalOpen_Confirm] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [teamMembers, setTeamMembers] = useState([])
  const [inventoryData, setInventoryData] = useState([])
  const [secondaryConfirmData, setSecondaryConfirmData] = useState([])
  const [showPassword, setShowPassword] = useState({})

  const fetchAdminList = async () => {
    const adminData = await getAdminData()
    var temp_data = []
    var tempEditableFields = []
    var tempCheckboxStates = {}

    for (let i = 0; i < adminData.data.odata.length; i++) {
      const dataObject = adminData.data.odata[i]
      const roles = dataObject.roles || []

      const data_to_be_pushed = {
        shown_id: dataObject.readicharge_unique_id,
        id: dataObject._id,
        name: dataObject.name,
        email: dataObject.email,
        phoneNumber: dataObject.phoneNumber,
        address: dataObject.address,
        roles: roles,
        adminType: roles.some((role) => ["Service", "Materials", "Labor Rate"].includes(role)) ? "Static" : "Dynamic",
      }

      temp_data.push(data_to_be_pushed)
      tempEditableFields.push(dataObject.email)
      tempCheckboxStates[dataObject.email] = roles.includes(dataObject.email)
    }

    setGetAdmin(temp_data)
    setEditableFields(tempEditableFields)
    setCheckboxStates(tempCheckboxStates)

    // Fetch team members data
    try {
      const teamData = await getTeamMemebers()
      if (teamData && teamData.data) {
        const teamMembersData = teamData.data.map((member, index) => ({
          id: member._id || index,
          name: member.name || "N/A",
          userName: member.username || "N/A",
          email: member.email || "N/A",
          role: member.role || "Customer Support",
          department: member.department || "Support",
          status: member.status || "Active",
          password: "Pass1/3#",
        }))
        setTeamMembers(teamMembersData)
        // Initialize showPassword state for team members
        const initialShowPassword = {}
        teamMembersData.forEach(member => {
          initialShowPassword[member.id] = false
        })
        // Initialize showPassword state for inventory data
        const inventoryShowPassword = {}
        inventoryData.forEach(item => {
          inventoryShowPassword[item.id] = false
        })
        setShowPassword({ ...initialShowPassword, ...inventoryShowPassword })
      }
    } catch (error) {
      console.error("Error fetching team members:", error)
    }

    // Mock inventory data
    const tempInventoryData = [
      {
        id: 1,
        name: "Inventory Admin 1",
        email: "Brian@Inventory.readicharge.com",
        password: "Pass123#",
      },
      {
        id: 2,
        name: "Inventory Admin 2",
        email: "DEV@Inventory.readicharge.com",
        password: "Pass123#",
      },
    ]
    setInventoryData(tempInventoryData)

    // Initialize showPassword state for inventory data
    const inventoryShowPassword = {}
    tempInventoryData.forEach(item => {
      inventoryShowPassword[item.id] = false
    })
    setShowPassword(prev => ({ ...prev, ...inventoryShowPassword }))

    // Mock secondary confirmation data
    setSecondaryConfirmData([
      {
        id: "ErSky",
        name: "Dev Team",
      },
      {
        id: "BrianA",
        name: "Brian O",
      },
      {
        id: "HillaryS",
        name: "Hillary ",
      },
      {
        id: "SuccessS",
        name: "Success",
      },
      {
        id: "ClaireS",
        name: "Claire ",
      },
      {
        id: "JohnS",
        name: "john",
      },
    ])
  }

  useEffect(() => {
    fetchAdminList()
  }, [])

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(`This field with ID ${id} will be permanently deleted. Are you sure?`)
    if (confirmDelete) {
      await deleteAdmin(id)
      fetchAdminList()
    }
  }

  const handleRoleCheckboxChange = async (adminId, role) => {
    const adminIndex = getAdmin.findIndex((admin) => admin.id === adminId)
    if (adminIndex !== -1) {
      const adminEmail = getAdmin[adminIndex].email
      const updatedRolesCopy = [...getAdmin]
      const adminRoles = updatedRolesCopy[adminIndex].roles || []

      if (adminRoles.includes(role)) {
        const updatedRoles = adminRoles.filter((r) => r !== role)
        updatedRolesCopy[adminIndex].roles = updatedRoles
      } else {
        updatedRolesCopy[adminIndex].roles = [...adminRoles, role]
      }

      setGetAdmin(updatedRolesCopy)
    }
  }

  const handleCellEditCommit = async ({ id, field, value }) => {
    const updatedAdmin = { ...getAdmin[id], [field]: value }
    await updateAdmin(id, updatedAdmin)
    fetchAdminList()
  }

  const handleEdit = (params) => {
    const selectedAdmin = getAdmin.find((admin) => admin.id === params.row.id)
    setSelectedRow(selectedAdmin)
    setOpen(true)
    setUpdatedValues(selectedAdmin)
  }

  const handleClose = () => {
    setOpen(false)
    setUpdatedValues({})
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setUpdatedValues((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleOpenModal_Confirm = () => {
    setModalOpen_Confirm(true)
  }

  const handleCloseModal_Confirm = () => {
    setModalOpen_Confirm(false)
  }

  const handleSave = async () => {
    await updateAdmin(selectedRow.id, updatedValues)
    handleClose()
    fetchAdminList()
  }

  const handleTogglePassword = (id) => {
    setShowPassword(prev => ({
      ...prev,
      [id]: true
    }))
    
    setTimeout(() => {
      setShowPassword(prev => ({
        ...prev,
        [id]: false
      }))
    }, 10000)
  }

  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  const navigate = useNavigate()

  const staticRoles = ["Service", "Material", "Labor"]
  const dynamicRoles = ["inventory-admin", "customer-support", "support-admin", "marketing", "web-editor"]

  const createColumns = (roles) => [
    {
      field: "shown_id",
      headerName: "ID",
      cellClassName: (params) => (params.row.email === "Brian@readicharge.com" ? "highlighted-row" : ""),
    },
    {
      field: "name",
      headerName: "Name",
      width: 100,
      cellClassName: "name-column--cell",
      editable: true,
      cellClassName: (params) => (params.row.email === "Brian@readicharge.com" ? "highlighted-row" : ""),
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      editable: false,
      cellClassName: (params) => (params.row.email === "Brian@readicharge.com" ? "highlighted-row" : ""),
    },
    ...roles.map((role) => ({
      field: role,
      headerName: role,
      flex: 1,
      editable: (params) => params.row.email === "Brian@readicharge.com",
      renderCell: (params) => (
        <Checkbox
          checked={params.row.roles.includes(params.field)}
          disabled={params.row.email === "Brian@readicharge.com"}
          onChange={() => handleRoleCheckboxChange(params.row.id, params.field)}
        />
      ),
      cellClassName: (params) => (params.row.email === "Brian@readicharge.com" ? "highlighted-row" : ""),
    })),
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) =>
        params.row.email === "Brian@readicharge.com" ? null : (
          <Box>
            <Button variant="outlined" color="warning" onClick={() => handleDelete(params.row.id)}>
              Delete
            </Button>
            <Button
              variant="outlined"
              style={{ marginLeft: "16px" }}
              color="primary"
              onClick={() => handleEdit(params)}
            >
              Edit
            </Button>
          </Box>
        ),
      cellClassName: (params) => (params.row.email === "Brian@readicharge.com" ? "highlighted-row" : ""),
    },
  ]

  const teamMembersColumns = [
    {
      field: "id",
      headerName: "ID",
      width: 100,
    },
    {
      field: "name",
      headerName: "Name",
      width: 150,
      cellClassName: "name-column--cell",
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 150,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    {
      field: "department",
      headerName: "Department",
      width: 150,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
    },
    {
      field: "password",
      headerName: "Password",
      width: 200,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          <TextField
            value={showPassword[params.row.id] ? params.row.password : "••••••••"}
            type={showPassword[params.row.id] ? "text" : "password"}
            InputProps={{ readOnly: true }}
            size="small"
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleTogglePassword(params.row.id)}
          >
            {showPassword[params.row.id] ? "Hide" : "Show"}
          </Button>
        </Box>
      ),
    },
  ]

  const inventoryColumns = [
    {
      field: "id",
      headerName: "ID",
      width: 100,
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      cellClassName: "name-column--cell",
    },
    {
      field: "email",
      headerName: "Email",
      width: 250,
    },
    {
      field: "password",
      headerName: "Password",
      width: 200,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          <TextField
            value={showPassword[params.row.id] ? params.row.password : "••••••••"}
            type={showPassword[params.row.id] ? "text" : "password"}
            InputProps={{ readOnly: true }}
            size="small"
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleTogglePassword(params.row.id)}
          >
            {showPassword[params.row.id] ? "Hide" : "Show"}
          </Button>
        </Box>
      ),
    },
  ]

  const secondaryConfirmColumns = [
    {
      field: "id",
      headerName: "ID",
      width: 150,
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      cellClassName: "name-column--cell",
    },
  ]

  const staticColumns = createColumns(staticRoles)
  const dynamicColumns = createColumns(dynamicRoles)

  return (
    <div style={{ overflowY: "auto", height: "calc(110vh)" }}>
      <Box m="20px">
        <Header title="Admin List" subtitle="Managing the Admins on the platform" />
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            "& .MuiTab-root": {
              color: "white",
              textTransform: "none",
            },
            "& .Mui-selected": {
              color: "green",
              fontWeight: "bold",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#96d232",
            },
          }}
        >
          <Tab label="Static Permissions" />
          <Tab label="Dynamic Permissions" />
          <Tab label="Customer Support" />
          <Tab label="Inventory Data" />
          <Tab label="Secondary Confirmation Password" />
        </Tabs>
        <Box
          m="40px 0 0 0"
          height="70vh"
          sx={{
            "& .MuiDataGrid-toolbar": {
              color: "#fff",
            },
            "& .MuiDataGrid-root": {
              border: "1px solid #06061E",
              backgroundColor: "#96D232",
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid #e1e1e1",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              borderTop: "1px solid #06061E",
              borderBottom: "1px solid #e1e1e1",
              color: "#06061E",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: "#EBEBEF",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid #e1e1e1",
              backgroundColor: "#96D232",
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[700]} !important`,
            },
            "& .MuiDataGrid-iconSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
            "& .MuiDataGrid-cellEditable": {
              backgroundColor: colors.greenAccent[100],
            },
            "& .highlighted-row": {
              backgroundColor: "#F0DD5D",
              fontWeight: "bold",
              fontSize: 16,
            },
          }}
        >
          {tabValue === 0 && (
            <DataGrid
              rows={getAdmin.filter((admin) => admin.adminType === "Static")}
              columns={staticColumns}
              components={{
                Toolbar: GridToolbar,
              }}
              disableSelectionOnClick
              onCellEditCommit={handleCellEditCommit}
            />
          )}
          {tabValue === 1 && (
            <DataGrid
              rows={getAdmin.filter((admin) => admin.adminType === "Dynamic")}
              columns={dynamicColumns}
              components={{
                Toolbar: GridToolbar,
              }}
              disableSelectionOnClick
              onCellEditCommit={handleCellEditCommit}
            />
          )}
          {tabValue === 2 && (
            <DataGrid
              rows={teamMembers}
              columns={teamMembersColumns}
              components={{
                Toolbar: GridToolbar,
              }}
              disableSelectionOnClick
            />
          )}
          {tabValue === 3 && (
            <DataGrid
              rows={inventoryData}
              columns={inventoryColumns}
              components={{
                Toolbar: GridToolbar,
              }}
              disableSelectionOnClick
            />
          )}
          {tabValue === 4 && (
            <DataGrid
              rows={secondaryConfirmData}
              columns={secondaryConfirmColumns}
              components={{
                Toolbar: GridToolbar,
              }}
              disableSelectionOnClick
            />
          )}
        </Box>
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Admin</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Name" name="name" value={updatedValues.name || ""} onChange={handleInputChange} />
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={updatedValues.email || ""}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <PasswordModal
        open={modalOpen_Confirm}
        onClose={handleCloseModal_Confirm}
        onSubmit={handleSave}
        title={"Confirm Admin Deletion"}
        action={"Confirm"}
        message={"Are you sure you want to delete this admin?"}
      />
    </div>
  )
}

export default AdminList
